
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import config from '@/configs'
import VueResource from 'vue-resource'
import { localRead } from '@/libs/util'
import * as filter from '@/util/filters'
import vueEsign from 'vue-esign'
import Vant from 'vant'
import 'vant/lib/index.css'
import './assets/js/rem'
import './assets/css/reset.css'

Vue.use(vueEsign)
Vue.use(Vant)
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
})

Vue.config.lang = 'zh-cn'

Vue.http.interceptors.push((request, next) => {
  let TOKEN = localRead('token')
  if (TOKEN) {
    request.params.token = TOKEN
  }
  next((response) => {
    return response
    // 增加参数, es6语法
    // return {...response.body, ok: false}
  })
})

/**
 * @description jsonp请求
 */
Vue.use(VueResource)
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/* 图片预览 */

/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config

Vue.http.options.emulateJSON = true
Vue.http.options.emulateHTTP = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
